import { createLightbox } from './nexus-interfaces/lightbox';
import { trackEvent } from './tracking';

export class CustomerReviewLightbox {
    public static async init(
        rootElement: HTMLElement,
        gallerySelector: string,
        imageSelector: string,
        position: 'top' | 'bottom'
    ): Promise<void> {
        let isFirstChange = true;
        const imagesElement = rootElement.querySelector<HTMLElement>(gallerySelector);
        if (!imagesElement) return;
        await createLightbox({
            gallery: imagesElement,
            children: imageSelector,
            thumbSelector: 'img',
            onOpen: (index, numItems) => {
                trackEvent({
                    product_ReviewImageView: position,
                    product_ReviewImageGallery: position === 'top' ? 'full_gallery' : 'single_review',
                    product_DifferentReviewImageChange: `${index + 1}|${numItems}`,
                });
            },
            onChange: (index, numItems) => {
                trackEvent({
                    product_ReviewImageView: isFirstChange ? 'change_first' : 'change_following',
                    product_ReviewImageGallery: position === 'top' ? 'full_gallery' : 'single_review',
                    product_DifferentReviewImageChange: `${index + 1}|${numItems}`,
                });
                isFirstChange = false;
            },
            onClose: () => {
                isFirstChange = true;
            },
        });
    }
}
